module.exports = __webpack_public_path__ + "static/media/Arrow down.9ad35d5e.svg";